import {
	PunchCard,
	PunchCardSkeleton,
} from "@/features/presence/components/punch-card";
import { useMyMembership } from "@/features/presence/hooks/use-my-membership";
import { useMyTimeEntries } from "@/features/presence/hooks/use-my-time-entries";
import { useNow } from "@/features/presence/hooks/use-now";
import {
	entriesForDate,
	hasOpenEntry,
	sumMinutes,
} from "@/features/presence/utils/day";
import { formatMinutes } from "@/features/presence/utils/format";
import { weekRange } from "@/features/presence/utils/week";
import { usePermissions } from "@/hooks/use-permissions.ts";
import { currentWorkDate, currentWorkDay } from "@/lib/format";

export function PresencePanel() {
	const { has } = usePermissions();
	const canClock = has("time_entries:clock");

	const range = weekRange(currentWorkDay());
	const entriesQuery = useMyTimeEntries(range, canClock);
	const { worker, isMember, isLoading, isError } = useMyMembership();

	const entries = entriesQuery.data ?? [];
	const todayEntries = entriesForDate(entries, currentWorkDate());
	const now = useNow(hasOpenEntry(todayEntries));

	if (isLoading || entriesQuery.isPending) {
		return <PunchCardSkeleton />;
	}

	if (isError || entriesQuery.isError || isMember === undefined) {
		return (
			<p className="dashboard-panel-error" role="status">
				Não foi possível carregar o seu ponto de hoje.
			</p>
		);
	}

	return (
		<div className="presence-panel">
			<PunchCard
				entries={todayEntries}
				isMember={isMember}
				timeClockEnabled={worker?.timeClockEnabled ?? false}
				canClock={canClock}
			/>
			<p className="presence-panel__hours">
				Horas trabalhadas hoje:{" "}
				<strong>{formatMinutes(sumMinutes(todayEntries, now))}</strong>
			</p>
		</div>
	);
}
